/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Flex } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

import { ContentScroll } from '../../../../../common/components/ContentScroll';
import type { Customer } from '../../../../../sushi/rules/types';
import { StatTable } from './StatTable';
import { commentData } from './constant';
import IconImg from '../../../../../assets/images/pages/sushi/icon_sushi_field_man.svg';

type Props = {
  customer: Customer,
};

export function CustomerComments(props: Props) {
  let { customer } = props;
  return (
    <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
      <StatTable>
        <Header>
          <tr>
            <th>お客さんアンケート</th>
          </tr>
        </Header>
        <tbody>
          {commentData[customer.gender][customer.ageGroup].map((survey, i) => (
            <tr key={i}>
              <td>
                <CustomerSurvey>
                  <CustomerAvatar src={IconImg} />
                  <SurveyContent>{survey.content}</SurveyContent>
                </CustomerSurvey>
              </td>
            </tr>
          ))}
        </tbody>
      </StatTable>
    </ContentScroll>
  );
}

const Header = styled('thead')(
  css({
    th: {
      textAlign: 'left',
      px: [12, 12, 16],
      py: [4, 4, 6],
    },
  })
);

const CustomerSurvey = styled(Flex)(
  css({
    py: [12, 12, 18],
    pr: [12, 12, 18],
    pl: [6, 6, 8],
  })
);

const CustomerAvatar = styled('img')(
  css({
    size: [28, 28, 42],
  })
);

const ARROW_WIDTH = [6, 6, 8];
const ARROW_TOP = [8, 8, 12];
const SurveyContent = styled(Box)(
  css({
    position: 'relative',
    flex: 1,
    px: [12, 12, 16],
    py: [8, 8, 10],
    ml: [6, 6, 8],
    bg: 'secondary8',
    borderRadius: [4, 4, 5],
    fontSize: [14, 14, 19],
    lineHeight: 'title',
    textAlign: 'left',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: ARROW_TOP,
      left: 0,
      bg: 'secondary8',

      // size^2 = arrowWidth^2 * 2 due to pythagorean theorem
      // size = sqrt(arrowWidth ^ 2 * 2)
      size: ARROW_WIDTH.map(x => (x ? `${Math.sqrt(x * x * 2)}px` : null)),

      // rotate 45deg and scale y
      transformOrigin: `top left`,
      transform: `scaleY(0.75) rotate(45deg)`,
    },
  })
);
